const mapStages = {
    '1': 'respondent-questions',
    '2': 'literacy',
    '3': 'numeracy',
    '4': 'problem-solving',
    '5': 'big5'
}

export default {
    namespaced: true,
    state: {
        steps: []
    },
    getters: {
        currentIndex (state, getters, rootState) {
            let index = state.steps.indexOf(rootState.session.route)
            return index === -1 ? 0 : index
        },
        current (state, getters) {
            return state.steps[getters.currentIndex]
        },
        next (state, getters) {
            let index = getters.currentIndex + 1
            return state.steps[index] || 'results'
        }
    },
    actions: {
        stages ({commit}, stages = []) {
            let steps = stages.map(key => mapStages[key])
            commit('steps', steps)
        },
        start ({commit, getters, dispatch}) {
            dispatch('session/push', getters.current, {root: true})
            commit('index', 0)
        },
        next ({commit, state, getters, dispatch}) {
            dispatch('session/push', getters.next, {root: true})
            commit('index', state.index + 1)
        },
        reset ({commit}) {
            commit('reset')
        }
    },
    mutations: {
        index (state, index) {
            state.index = index
        },
        reset (state) {
            state.index = 0
        },
        steps (state, steps) {
            state.steps = steps
        }
    }
}
